import { useEffect } from 'react';
import { Modal, Box, Typography, Button, CircularProgress, Stack } from '@mui/material';
import { SwishProps } from '../types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { deviceType } from '@/utils/device';
import swishLogo from '@/assets/swish.png?w=100&h=100&format=webp&imagetools';
import { usePaymentSession } from '@/hooks/payment/usePaymentSession';
import { failedPaymentStatuses, successfulPaymentStatuses } from '@/utils/constants';

const Swish = ({
  open,
  showQRCode,
  onClose,
  onCancel,
  onConfirm,
  onConfirmOtherDevice,
  qrCodeBlob,
  isProcessingPayment = false
}: SwishProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { paymentSession } = usePaymentSession();

  useEffect(() => {
    if (paymentSession && paymentSession.payment.methodCode?.toLowerCase() === 'swish') {
      if (successfulPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        navigate(`/pay/confirmation/${paymentSession.paymentSessionId}`, { replace: true });
      } else if (failedPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        onClose();
      }
    }
  }, [paymentSession]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: 2,
          width: '90%',
          maxWidth: '400px',
          p: 3,
          boxShadow: 24,
          textAlign: 'center'
        }}
      >
        {showQRCode && qrCodeBlob ? (
          <Stack alignItems='center'>
            <Typography variant='body2' align='center'>
              {t('page.pay.swish-modal.timelimit')}
            </Typography>
            <img src={qrCodeBlob} alt='Swish QR Code' style={{ maxWidth: '100%', height: 'auto' }} />
            <Typography
              variant='body2'
              color='primary'
              sx={{
                cursor: 'pointer'
              }}
              onClick={onCancel}
            >
              {t('buttons.cancel')}
            </Typography>
          </Stack>
        ) : (
          <Stack gap={2} alignItems='center'>
            <img src={showQRCode ? undefined : swishLogo} alt='Swish Logo' style={{ width: '80px', height: '80px' }} />
            <Typography variant='body2' align='center'>
              {t('page.pay.swish-modal.title')}
            </Typography>
            {isProcessingPayment ? (
              <CircularProgress />
            ) : (
              <Stack gap={1} alignItems='center' sx={{ width: '100%' }}>
                {deviceType === 'Mobile' && (
                  <Button variant='contained' color='primary' fullWidth onClick={onConfirm}>
                    {t('page.pay.swish-modal.open-app-button')}
                  </Button>
                )}
                <Button variant='outlined' fullWidth onClick={onConfirmOtherDevice}>
                  {t('page.pay.swish-modal.other-device-button')}
                </Button>
              </Stack>
            )}
            <Typography
              marginTop={1}
              variant='body2'
              color='primary'
              sx={{
                cursor: 'pointer'
              }}
              onClick={onCancel}
            >
              {t('buttons.cancel')}
            </Typography>
          </Stack>
        )}
      </Box>
    </Modal>
  );
};

export default Swish;
